import React from 'react'

function StartMetagameInstance () {
  return (
    <iframe
      title='Start Your Game'
      src='https://wiki.metagame.wtf/'
      style={{ height: '100%', width: '100%', border: '0px' }}
    />
  )
}

export default StartMetagameInstance
